import { Tab } from '@ui-kitten/components';
export default Tab;
//# sourceMappingURL=Tab.js.map